import React from 'react';
import {Card} from "@mui/material";
import {Grid, Typography} from "@material-ui/core";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";

const WhyUsCard = () => {
    return (
        <Box sx={{paddingLeft: {xs: 3, sm: 1}, paddingBottom: 2, marginTop: {xs: '6rem'}, marginBottom: {xs: '4rem'}}}>
            <Grid container spacing={2} >
                <Grid item >
                    <Card raised={true} sx={{
                        backgroundColor: '#DE5103', borderRadius: '20px', width: '155px',
                        height: '193px', display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center',
                    }}>
                        <CardContent >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: 10}}>
                                <path d="M17.1476 0.592011L11.7889 17.132L0.532895 5.71426L17.1476 0.592011Z" fill="white"/>
                            </svg>
                            <Typography variant='h6' tp={3} lh={0} sx={{ lineHeight: 2, m: 1 }} style={{ fontSize: 18, color: '#ffffff'}} >
                            Online/Offline Classrooms
                            </Typography>
                             <Typography variant='h3' tp={5} style={{ fontSize: 12, color: '#ffffff' }} >
                             Experience interactive classes
                            </Typography>
                        </CardContent>
                        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{
                            width: '22px',
                            height: '22px',
                            marginLeft: '70%',
                        }}>
                            <circle cx="11" cy="11" r="11" fill="white"/>
                        </svg>
                    </Card>
                </Grid>

                {/*##############################################################################################################################33*/}

                <Grid item>
                    <Card raised={true} sx={{
                        backgroundColor: '#fff ', borderRadius: '20px', width: '155px',
                        height: '193px',  display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'
                    }}>
                        <CardContent >
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6.5" cy="6.5" r="6.5" fill="#DE5103"/>
                            </svg>

                            <Typography variant='h6' style={{ fontSize: 18}} >
                            Personal Mentor
                            </Typography>
                            <Typography variant='h3' style={{ fontSize: 12}} >
                            Get direct support from our Tutors
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                {/*##############################################################################################################################33*/}

                <Grid item>
                    <Card raised={true} sx={{
                        backgroundColor: '#fff ', borderRadius: '20px', width: '155px',
                        height: '193px', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center',
                    }}>
                        <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '80%'}}>
                            <path d="M0.0608415 0.182955L19.0787 11.5964L1.65282 22.3056L0.0608415 0.182955Z" fill="#DE5103"/>
                        </svg>
                        <CardContent >

                            <Typography variant='h6' style={{ fontSize: 18}} >
                            College Admission
                            </Typography>
                            <Typography variant='h3' style={{ fontSize: 12}} >
                            Get help in college searching
                            </Typography>
                        </CardContent>
                        <svg width="19" height="12" viewBox="0 0 19 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="5.96367" width="13.4591" height="13.4591" transform="rotate(-26.3016 0 5.96367)" fill="#DE5103"/>
                        </svg>

                    </Card>
                </Grid>

                {/*##############################################################################################################################33*/}

                <Grid item>
                    <Card raised={true} sx={{
                        backgroundColor: '#fff ', borderRadius: '20px', width: '155px',
                        height: '193px', display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center'
                    }}>
                        <svg width="31" height="16" viewBox="0 0 31 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="15.5" cy="0.5" r="15.5" fill="#DE5103"/>
                        </svg>

                        <CardContent >
                            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6.5" cy="6.5" r="6.5" fill="#DE5103"/>
                            </svg>

                            <Typography variant='h6' style={{ fontSize: 18}} >
                            Lifetime Chat Support
                            </Typography>
                            <Typography variant='h3' style={{ fontSize: 12}} >
                            Don't wait. Chat with us instantly
                            </Typography>
                        </CardContent>
                        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '85%'}}>
                            <rect x="-1" y="5.96367" width="13.4591" height="13.4591" transform="rotate(-26.3016 -1 5.96367)" fill="#DE5103"/>
                        </svg>

                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default WhyUsCard;